import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/trial-accounts";

export default {
  index() {
    return AxiosFactory.get(`${resource}`);
  },
  update(id, payload) {
    return AxiosFactory.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return AxiosFactory.delete(`${resource}/${id}`);
  }
};
